import { pathOr } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router";

import { expireSession, resetUser } from "../login/actions";
import selectorsToProps from "../utils/selectorsToProps";
import { getUrlToRedirectAfterLogout, saveRedirectUrl } from "./LocalStorage";
import { isUserAuthenticated } from "./selector";

export interface AuthRouteProps extends RouteProps {
  resetUser: typeof resetUser;
  isUserAuthenticated: boolean;
}

export class AuthRoute extends React.Component<AuthRouteProps, {}> {
  constructor(props: AuthRouteProps) {
    super(props);
  }
  public render() {
    const { component: Component, ...rest } = this.props;
    return <Route {...rest} render={this.renderFn} />;
  }

  public componentDidUpdate(prevProps: AuthRouteProps) {
    if (!this.props.isUserAuthenticated) {
      this.props.resetUser({ errorMessage: "" });
    }
  }

  private renderFn = (renderProps: RouteComponentProps<any>) => {
    const redirectUrl = pathOr("/", ["props", "location", "pathname"], this);
    saveRedirectUrl(redirectUrl);

    if (this.props.isUserAuthenticated) {
      const { component: Component } = this.props;
      if (!Component) {
        return null;
      }
      return <Component {...renderProps} />;
    }

    return (
      <Redirect
        to={{
          pathname: getUrlToRedirectAfterLogout() as string
        }}
      />
    );
  };
}

export default connect(
  selectorsToProps({
    isUserAuthenticated
  }),
  {
    resetUser,
    expireSession: expireSession.action
  }
)(AuthRoute);



// WEBPACK FOOTER //
// ./src/route/AuthRoute.tsx